import CPP from './cpp';

const cppRoutes = [
  { path: 'cpp', element: <CPP /> },
  { path: 'ppc', element: <CPP /> },
];

export default cppRoutes;
